export const AccessToken = 'accessToken'
export const AccessTokenExpiry = 'accessTokenExpiry'
export const AuthAccount = 'authAccount'
export const RedirectUrlAfterLogin = 'postAuthRedirectUrl'
export const UserCompany = 'userCompany'
export const UserFeatures = 'userFeatures'
export const UserProfile = 'userProfile'
export const WidgetState = 'widgetState'
